import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
} from "../../../utils/reduxHelper";

export const sourcingProductReduxAPI = createApi({
  reducerPath: "sourcingProductReduxAPI",
  baseQuery: baseQueryWithArgs,

  tagTypes: ["productDetails", "productColorOptions", "productVariants"],

  endpoints: (builder) => ({
    //GET Queries
    getProductDetails: builder.query({
      query: ({ productId, isBrandSourcing }) =>
        getQueryStringWithCreator(
          `s/getProductDetails?productId=${productId}&isBrandSourcing=${isBrandSourcing}`
        ),
      providesTags: ["productDetails"],
    }),
    getProductVariants: builder.query({
      query: ({ productId, isBrandSourcing }) => {
        return getQueryStringWithCreator(
          `s/getProductVariants?productId=${productId}&isBrandSourcing=${isBrandSourcing}`
        );
      },
      providesTags: ["productVariants"],
    }),
    getProductColorOptions: builder.query({
      query: ({ productId }) =>
        getQueryStringWithCreator(
          `s/getProductColorOptions?productId=${productId}`
        ),
      providesTags: ["productColorOptions"],
    }),
    getProductSizeChart: builder.query({
      query: ({ productId }) =>
        getQueryStringWithCreator(
          `s/getProductSizeChart?productId=${productId}`
        ),
    }),
    /** PDP sidecars (creator PDP). Backed by sourcing/views/pdp_views.py. */
    getProductReelsForPdp: builder.query({
      query: ({ productId, page = 1, limit = 10 }) =>
        getQueryStringWithCreator(
          `s/getProductReelsForPdp?productId=${productId}&page=${page}&limit=${limit}`
        ),
      transformResponse: (res) =>
        res?.data || { content: [], page: 1, done: true },
    }),
    getProductAttributesForPdp: builder.query({
      query: ({ productId }) =>
        getQueryStringWithCreator(
          `s/getProductAttributesForPdp?productId=${productId}`
        ),
      transformResponse: (res) =>
        res?.data || { description: "", productDetail: {}, reviews: null },
    }),
    getSimilarProductsForPdp: builder.query({
      query: ({ productId, page = 1, limit = 10 }) =>
        getQueryStringWithCreator(
          `s/getSimilarProductsForPdp?productId=${productId}&page=${page}&limit=${limit}`
        ),
      transformResponse: (res) =>
        res?.data || { products: [], page: 1, done: true },
    }),
    getPdpServiceability: builder.query({
      query: ({ productId, pincode, variantId }) => {
        let url = `s/getPdpServiceability?productId=${productId}&pincode=${pincode}`;
        if (variantId != null) url += `&variantId=${variantId}`;
        return getQueryStringWithCreator(url);
      },
      transformResponse: (res) => res?.data ?? res,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetProductDetailsQuery,
  useLazyGetProductVariantsQuery,
  useLazyGetProductColorOptionsQuery,
  useLazyGetProductSizeChartQuery,
  useGetProductReelsForPdpQuery,
  useGetProductAttributesForPdpQuery,
  useGetSimilarProductsForPdpQuery,
  useLazyGetPdpServiceabilityQuery,
} = sourcingProductReduxAPI;
